export function MsgDeskLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#dfe6ef] px-4 font-[Verdana,Arial,Helvetica,sans-serif] text-[11px] text-black">
      <div className="w-full max-w-md border border-[#006699] bg-[#eef3f8]">
        <div className="bg-[#006699] px-3 py-1 font-bold text-white">MsgDesk Forum</div>
        <div className="p-4 text-center">Loading forum topic…</div>
      </div>
    </div>
  )
}
